import {IconProps} from '../IconProps'
import {classList} from '@peachy/utility-kit-pure'
import styles from './Spinner.module.css'

export function Spinner(props: IconProps) {
    const classes = classList(styles.spinner, 'peachy-spinner fa-duotone fa-spinner-third', props.class)
    return <i class={classes}></i>
}
